<div class="mt-1" (click)="hideDropdowns();">
    <div class="row" style="border-bottom: 1px solid #d0d0ce;">
      <div class="col-md-1">
        <h1>Offices</h1>
      </div>    
      <div class="col-md-11 col-xl-11 d-flex justify-content-end">
        <div class="row d-flex justify-content-end">
          <div class="col-md-4 col-xl-8  d-flex justify-content-end headermargin">
            <div class="form-group has-search">
              <span class="icon-ic_search form-control-search"></span>
              <input class="form-control frontIcon searchtext" #userame id="username" autocomplete="off" placeholder="Search by office">
            </div>
            <button (click)="SearchByUser(userame.value)" class="button ml-3 mr-auto" type="button">
              Search
            </button>
            <div class="separator"></div>
          </div>
        <div class="col-md-5 col-xl-4 d-flex justify-content-end">
            
            <button (click)="ResetFilters()" class="button" type="button">
              Reset
            </button>
            <button (click)="addOffice()" class="button blue" type="button">
              Add Office
            </button>
          </div>
      </div>
    </div>
  </div>
  
  </div>
